import { Injectable } from '@angular/core';
import { MultiMapAccessPoint, MultiMapState } from '@models/multimap';

@Injectable({
  providedIn: 'root'
})
export class MultiMapContextService {

  // Default options are Global Position alert button access options as it can't pass params
  private state: MultiMapState = {
    policy: null,
    pageCanReturn: false,
    accessPoint: MultiMapAccessPoint.DEEPLINK
  };

  constructor() { }

  getState() {
    return this.state;
  }

  setState(state: MultiMapState) {
    this.state = state;
  }

  updateState(fieldsToUpdate: Partial<MultiMapState>) {
    this.state = {
      ...this.state,
      ...fieldsToUpdate
    };
  }

  clearState() {
    this.state = {
      policy: null,
      pageCanReturn: false,
      accessPoint: MultiMapAccessPoint.DEEPLINK
    };
  }
}
